export default "__VITE_ASSET___wvoajLA__"